/* eslint-disable */

export const protobufPackage = "od_protos.common.sell";

export enum WalkInitiator {
  WALK_INITIATOR_UNKNOWN = 0,
  WALK_INITIATOR_OPENDOOR = 1,
  WALK_INITIATOR_SELLER = 2,
  UNRECOGNIZED = -1,
}

export function walkInitiatorFromJSON(object: any): WalkInitiator {
  switch (object) {
    case 0:
    case "WALK_INITIATOR_UNKNOWN":
      return WalkInitiator.WALK_INITIATOR_UNKNOWN;
    case 1:
    case "WALK_INITIATOR_OPENDOOR":
      return WalkInitiator.WALK_INITIATOR_OPENDOOR;
    case 2:
    case "WALK_INITIATOR_SELLER":
      return WalkInitiator.WALK_INITIATOR_SELLER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WalkInitiator.UNRECOGNIZED;
  }
}

export function walkInitiatorToJSON(object: WalkInitiator): string {
  switch (object) {
    case WalkInitiator.WALK_INITIATOR_UNKNOWN:
      return "WALK_INITIATOR_UNKNOWN";
    case WalkInitiator.WALK_INITIATOR_OPENDOOR:
      return "WALK_INITIATOR_OPENDOOR";
    case WalkInitiator.WALK_INITIATOR_SELLER:
      return "WALK_INITIATOR_SELLER";
    case WalkInitiator.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum OpendoorWalkReason {
  OPENDOOR_WALK_REASON_UNKNOWN = 0,
  OPENDOOR_WALK_REASON_SEE_UNDERWRITING = 1,
  OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION = 2,
  OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM = 3,
  OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY = 4,
  OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE = 5,
  OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE = 6,
  OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK = 7,
  UNRECOGNIZED = -1,
}

export function opendoorWalkReasonFromJSON(object: any): OpendoorWalkReason {
  switch (object) {
    case 0:
    case "OPENDOOR_WALK_REASON_UNKNOWN":
      return OpendoorWalkReason.OPENDOOR_WALK_REASON_UNKNOWN;
    case 1:
    case "OPENDOOR_WALK_REASON_SEE_UNDERWRITING":
      return OpendoorWalkReason.OPENDOOR_WALK_REASON_SEE_UNDERWRITING;
    case 2:
    case "OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION":
      return OpendoorWalkReason.OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION;
    case 3:
    case "OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM":
      return OpendoorWalkReason.OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM;
    case 4:
    case "OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY":
      return OpendoorWalkReason.OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY;
    case 5:
    case "OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE":
      return OpendoorWalkReason.OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE;
    case 6:
    case "OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE":
      return OpendoorWalkReason.OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE;
    case 7:
    case "OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK":
      return OpendoorWalkReason.OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OpendoorWalkReason.UNRECOGNIZED;
  }
}

export function opendoorWalkReasonToJSON(object: OpendoorWalkReason): string {
  switch (object) {
    case OpendoorWalkReason.OPENDOOR_WALK_REASON_UNKNOWN:
      return "OPENDOOR_WALK_REASON_UNKNOWN";
    case OpendoorWalkReason.OPENDOOR_WALK_REASON_SEE_UNDERWRITING:
      return "OPENDOOR_WALK_REASON_SEE_UNDERWRITING";
    case OpendoorWalkReason.OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION:
      return "OPENDOOR_WALK_REASON_ADJACENT_TO_STABILIZATION";
    case OpendoorWalkReason.OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM:
      return "OPENDOOR_WALK_REASON_OPENDOOR_ADDENDUM";
    case OpendoorWalkReason.OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY:
      return "OPENDOOR_WALK_REASON_PRICING_UNCERTAINTY";
    case OpendoorWalkReason.OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE:
      return "OPENDOOR_WALK_REASON_REPAIR_ASSESSMENT_INCOMPLETE";
    case OpendoorWalkReason.OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE:
      return "OPENDOOR_WALK_REASON_REPAIR_SCOPE_OF_WORK_TOO_LARGE";
    case OpendoorWalkReason.OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK:
      return "OPENDOOR_WALK_REASON_FAILED_ELIGIBILITY_RECHECK";
    case OpendoorWalkReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SellerWalkReason {
  SELLER_WALK_REASON_UNKNOWN = 0,
  SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME = 1,
  SELLER_WALK_REASON_NOT_SELLING = 2,
  SELLER_WALK_REASON_NET_CASH = 3,
  SELLER_WALK_REASON_OTHER_REASON = 4,
  SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK = 5,
  SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER = 6,
  SELLER_WALK_REASON_HOME_IS_LISTED = 7,
  SELLER_WALK_REASON_LEGAL_ISSUES = 8,
  SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED = 9,
  SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION = 10,
  UNRECOGNIZED = -1,
}

export function sellerWalkReasonFromJSON(object: any): SellerWalkReason {
  switch (object) {
    case 0:
    case "SELLER_WALK_REASON_UNKNOWN":
      return SellerWalkReason.SELLER_WALK_REASON_UNKNOWN;
    case 1:
    case "SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME":
      return SellerWalkReason.SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME;
    case 2:
    case "SELLER_WALK_REASON_NOT_SELLING":
      return SellerWalkReason.SELLER_WALK_REASON_NOT_SELLING;
    case 3:
    case "SELLER_WALK_REASON_NET_CASH":
      return SellerWalkReason.SELLER_WALK_REASON_NET_CASH;
    case 4:
    case "SELLER_WALK_REASON_OTHER_REASON":
      return SellerWalkReason.SELLER_WALK_REASON_OTHER_REASON;
    case 5:
    case "SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK":
      return SellerWalkReason.SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK;
    case 6:
    case "SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER":
      return SellerWalkReason.SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER;
    case 7:
    case "SELLER_WALK_REASON_HOME_IS_LISTED":
      return SellerWalkReason.SELLER_WALK_REASON_HOME_IS_LISTED;
    case 8:
    case "SELLER_WALK_REASON_LEGAL_ISSUES":
      return SellerWalkReason.SELLER_WALK_REASON_LEGAL_ISSUES;
    case 9:
    case "SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED":
      return SellerWalkReason.SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED;
    case 10:
    case "SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION":
      return SellerWalkReason.SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SellerWalkReason.UNRECOGNIZED;
  }
}

export function sellerWalkReasonToJSON(object: SellerWalkReason): string {
  switch (object) {
    case SellerWalkReason.SELLER_WALK_REASON_UNKNOWN:
      return "SELLER_WALK_REASON_UNKNOWN";
    case SellerWalkReason.SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME:
      return "SELLER_WALK_REASON_CANNOT_FIND_NEW_HOME";
    case SellerWalkReason.SELLER_WALK_REASON_NOT_SELLING:
      return "SELLER_WALK_REASON_NOT_SELLING";
    case SellerWalkReason.SELLER_WALK_REASON_NET_CASH:
      return "SELLER_WALK_REASON_NET_CASH";
    case SellerWalkReason.SELLER_WALK_REASON_OTHER_REASON:
      return "SELLER_WALK_REASON_OTHER_REASON";
    case SellerWalkReason.SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK:
      return "SELLER_WALK_REASON_POST_INSPECTION_OPENDOOR_ASK";
    case SellerWalkReason.SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER:
      return "SELLER_WALK_REASON_COMPETITION_OR_INVESTOR_OFFER";
    case SellerWalkReason.SELLER_WALK_REASON_HOME_IS_LISTED:
      return "SELLER_WALK_REASON_HOME_IS_LISTED";
    case SellerWalkReason.SELLER_WALK_REASON_LEGAL_ISSUES:
      return "SELLER_WALK_REASON_LEGAL_ISSUES";
    case SellerWalkReason.SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED:
      return "SELLER_WALK_REASON_CLOSE_OF_ESCROW_EXTENSION_DENIED";
    case SellerWalkReason.SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION:
      return "SELLER_WALK_REASON_HOA_SOLAR_CITY_INSPECTION";
    case SellerWalkReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
